import styled from 'styled-components';

export const EbonValidationPageContainer = styled.main`
    .mainContainer {
        width: 100%;
        display: flex;
        justify-content: center;
        flex-direction: column-reverse;
        align-self: center;
        align-items: center;
    }

    .text {
        background-color: white;
    }

    h3 {
        margin-bottom: 10px;
    }

    .goBack {
        margin: 20px 0 0;

        .fakelink {
            display: flex;
            align-items: center;
            cursor: pointer;
            max-width: 150px;

            & span {
                display: flex;

                svg {
                    transform: rotate(180deg);
                    margin-right: 5px;

                    .chevron {
                        fill: ${props => props.theme.linkColor};
                    }
                }
            }
        }
    }

    .loading {
        margin-top: 30px;
    }

    @media (min-width: ${props => props.theme.medium}) {
        .mainContainer {
            flex-direction: row;
            align-items: flex-start;
        }
    }

    @media (max-width: ${props => props.theme.medium}) {
        .mainContainer {
            flex-direction: column;
        }
    }
`;



// WEBPACK FOOTER //
// ./src/components/pages/ebon/ValidationEbonPageStyle.js